import CreateSetupBackend from "../config/config.js";
import { isMutual } from "../../utils/isMutual.jsx";

let SetupBackend = null;

function create(data) {
  SetupBackend = CreateSetupBackend();
  if (isMutual()) {
    const email = sessionStorage.getItem("emailUser");

    const cleanOnlyNumbers = (value = "") => String(value).replace(/\D/g, "");
    const normalizeAmountValue = (value) => {
      const parsed = Number(String(value ?? 0).replace(",", "."));
      if (Number.isNaN(parsed)) {
        return "0";
      }
      return String(parsed);
    };

    const keyType = (data?.creditParty?.dictType || "").toUpperCase();

    const rawPixKey = data?.creditParty?.key || "";
    const rawDocumentNumber = data?.creditParty?.taxId || "";

    const pixKey =
      keyType === "CPF" || keyType === "CNPJ" || keyType === "PHONE"
        ? cleanOnlyNumbers(rawPixKey)
        : rawPixKey;

    const documentNumber = cleanOnlyNumbers(rawDocumentNumber);
    const documentType = documentNumber.length === 14 ? "CNPJ" : "CPF";
    const externalId = data?.clientCode || `payout-${Date.now()}`;
    const amountValue = normalizeAmountValue(data?.amount);
    const description =
      String(data?.remittanceInformation || "").trim() || "Depósito Higher";

    const qrCodeData = String(
      data?.qrCodeData || data?.paymentData?.qrCodeData || "",
    ).trim();

    const payload = {
      externalId,
      amount: {
        currency: "BRL",
        value: amountValue,
      },
      // pixKey e qrcodeData são mutuamente exclusivos no contrato da Gowd:
      // enviar os dois faz a Gowd devolver INTERNAL_ERROR.
      initiationType: qrCodeData
        ? data?.initiationType || "STATIC_QRCODE"
        : data?.initiationType === "DICT"
          ? "KEY"
          : data?.initiationType || "KEY",
      paymentData: qrCodeData
        ? { qrCodeData }
        : { pixKey: keyType === "PHONE" ? "+55" + pixKey : pixKey },
      paymentMethod: "PIX",
      description,
      idempotencyKey: externalId,
    };

    if (data?.debitParty?.account) {
      payload.accountId = data.debitParty.account;
    }

    if (data?.creditParty?.name || documentNumber) {
      payload.receiver = {
        name: data?.creditParty?.name || "",
        document: {
          type: documentType,
          number: documentNumber,
        },
      };
    }

    const twoFactorQuery = data?.twoFactorCode
      ? `&twoFactorCode=${encodeURIComponent(data.twoFactorCode)}`
      : "";

    return SetupBackend.post(
      `/v1/baas/order-payouts?email=${email}${twoFactorQuery}`,
      payload,
    )
      .catch((err) => {
        const requiresRequestWrapper =
          err?.response?.status === 400 &&
          Array.isArray(err?.response?.data?.errors?.request);

        if (!requiresRequestWrapper) {
          throw err;
        }

        return SetupBackend.post(
          `/v1/baas/order-payouts?email=${email}${twoFactorQuery}`,
          {
            request: payload,
          },
        );
      })
      .then((res) => ({
        ...res,
        data: {
          ...(res?.data || {}),
          body: res?.data?.body || res?.data,
        },
      }));
  }

  return SetupBackend.post("/v1/pix/cashout/create", data);
}

function showEmv(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(
    `/v1/pix/cashout/showqrcode?email=${data.email}`,
    data,
  );
}

function createEmvPayment(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/pix/cashout/withdrawalqrcode", data);
}

function createBankDataPayment(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/pix/cashout/withdrawalbankaccount", data);
}

function indexParticipants(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/pix/cashout/indexparticipants?ISPB=${data.ISPB}&Name=${data.name}`,
  );
}

function showPayment(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/pix/cashout/showpayment?id=${data.id}&email=${sessionStorage.getItem(
      "emailUser",
    )}`,
  );
}

function showPixKey(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/pix/cashout/showpixkey/${sessionStorage.getItem("account")}?key=${
      data.key
    }`,
  );
}

function sendBatchPayments(file) {
  const SetupBackend = CreateSetupBackend();

  const formData = new FormData();
  formData.append("file", file);

  const email = sessionStorage.getItem("emailUser");

  return SetupBackend.post(`/v1/pix/cashout/lot-payment/${email}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

function sendBatchPaymentsBankAccount(file) {
  const SetupBackend = CreateSetupBackend();

  const formData = new FormData();
  formData.append("file", file);

  const email = sessionStorage.getItem("emailUser");

  return SetupBackend.post(
    `/v1/pix/cashout/lot-payment-bank-data/${email}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
}

function sendBatchPaymentsTed(file) {
  const SetupBackend = CreateSetupBackend();

  const formData = new FormData();
  formData.append("file", file);

  const email = sessionStorage.getItem("emailUser");

  return SetupBackend.post(
    `/v1/pix/cashout/lot-payment-ted/${email}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
}

function verifyBill(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(
    `/v1/pix/cashout/verifybill?email=${sessionStorage.getItem("emailUser")}`,
    data,
  );
}

function payBill(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(
    `/v1/pix/cashout/paybill?email=${sessionStorage.getItem("emailUser")}`,
    data,
  );
}

const backendServices = {
  create,
  indexParticipants,
  showPayment,
  showPixKey,
  sendBatchPayments,
  showEmv,
  createEmvPayment,
  createBankDataPayment,
  sendBatchPaymentsBankAccount,
  sendBatchPaymentsTed,
  verifyBill,
  payBill,
};

export default backendServices;
